export const LOCAL_REDIRECTION_PATHS = [
  "assessments/welcome",
  "assessments/questions",
  "assessments/finish",
];
